import React from 'react';

class QuestionCounter extends React.Component {
  render() {
    let questionCounter = '';
    if (this.props.count) {
      if (this.props.count === 1) {
        questionCounter = `${this.props.count} ${
          this.props.noun ? this.props.noun : 'Chapter'
        }`;
      } else {
        questionCounter = `${this.props.count} ${
          this.props.noun ? `${this.props.noun}s` : 'Chapters'
        }`;
      }

      questionCounter = (
        <span className="badge badge-default badge-md">{questionCounter}</span>
      );
    } else {
      questionCounter = '';
    }
    return questionCounter;
  }
}

export default QuestionCounter;
